export const useUserPermissions = () => {
  // Return from context or localStorage, etc.
  const data = JSON.parse(localStorage.getItem("data"));
  return data?.permissions || []; // ⬅️ change this based on logged-in user
};
